import { BookingPopupContainer } from '../../../../components/containers/VerticalBookingContainer/BookingPopupContainer';
import preloadCustomProps from '../../../utils/preloads/preloadStaticContainerProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'verticals-booking-popup',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: BookingPopupContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
